import { SEO } from "@/functional/seo";
import { siteQuery } from "@/libs/cmsClient";
import { routes } from "@/libs/constants/routes";
import { queryToString } from "@/libs/middleware/query";
import { AppLayout } from "@/ui/app-layout";
import { H1, H4, H6 } from "@blueprintjs/core";
import { SiteConfig } from "@solace/types";
import Link from "next/link";
import { useRouter } from "next/router";

import { LoginForm } from "@/functional/login-form";
import { AuthAction, withAuthUser } from "next-firebase-auth";

interface LoginProps {
  site: SiteConfig;
}

const Login: React.FC<LoginProps> = (props) => {
  const router = useRouter();
  const params = new URLSearchParams(queryToString(router.query));

  return (
    <AppLayout className="bg-gray-900" menus={props.site?.menus}>
      <div>
        <SEO path={routes.LOGIN} page={{ title: "Log In", description: "" }} />
        <div className=" py-6 md:py-8 ">
          <div className="wrapper">
            {/* <Container> */}
            <div className="max-w-sm mx-auto md:py-8">
              <LoginForm>
                <div>
                  <H4 className="font-normal text-primary-100">
                    Welcome back.
                  </H4>
                  <H1 className="text-primary-100">Login</H1>
                  <H6 className="font-normal text-primary-100">
                    New here?{" "}
                    <Link
                      href={routes.SIGNUP + "?" + params.toString()}
                      className="font-bold text-primary-100 hover:text-secondary-500"
                    >
                      Sign Up
                    </Link>
                  </H6>
                </div>
              </LoginForm>
            </div>
            {/* </Container> */}
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export const getStaticProps = async () => {
  try {
    const response = await siteQuery();
    const ret = {
      props: {
        site: response.data?.site[0],
      },
      // revalidate: 1200,
    };
    return ret;
  } catch (e) {
    console.error(e);
    return {
      props: {},
    };
  }
};

export default withAuthUser<LoginProps>({
  whenUnauthedAfterInit: AuthAction.RENDER,
  whenAuthedBeforeRedirect: AuthAction.RENDER,
  whenAuthed: AuthAction.REDIRECT_TO_APP,
})(Login);
